import { Injectable } from '@angular/core';
import { HTTPWrapperContext, RequestConfigImplementation, REQUEST_METHODS, XHR_STRATEGIES } from '@ptl/xhr';
import { AEMDocument } from './interfaces/AEM-document-retrieval.interface';

@Injectable({
  providedIn: 'root'
})
export class AemDocumentSearchService {

  constructor(
    private httpClient: HTTPWrapperContext
  ) { }

  async getDamData(servicePath: string, docRoot: string, tags: string[]): Promise<AEMDocument[]> {

    // console.log('servicePath', servicePath);
    // console.log('docRoot', docRoot);

    /**
     * https://medicaredenv2.highmark.com
     * /content/highmark/en/highmarkbcbs/shopx/resources/individual.assetsWithTags.json
     * ?docRoot=/content/dam/highmark/en/healthco/individualdocs
     * &queryType=textsearch
     * &start=0
     * &limit=3
     */

    const requestConfigImplementation = new RequestConfigImplementation({
      method: REQUEST_METHODS.GET,
      url: servicePath,
      GET_PAYLOAD: {
        docRoot: docRoot, // '/content/dam/highmark/en/healthco/individualdocs',
        // queryType: 'textsearch',
        query: tags.join(','),
        start: 0,
        limit: '1000'
      }
    });

    /** This should probably be 'datapower' strategy when not in local - or - Apache needs to be better config'd */
    this.httpClient.setStrategy(XHR_STRATEGIES.MOCK);
    return this.httpClient.makeRequest<AEMDocument[]>(requestConfigImplementation)
      .then((response: AEMDocument[]) => {
        response.forEach(item => {
          Object.keys(item).forEach(k => {
            if (typeof item[k] === 'string') {
              item[k] = (item[k] as string).trim();
            } else {
              if ( (item[k] as string[]).push) {
                item[k] = (item[k] as string[]).map( s => s.trim() )
              }
            }
          });
          /** Provide default value for tagless items (allows the dropdown to have a value) */
          // if (!item.type) { item.type = ['(Empty)']; }
          // if (!item.topic) { item.topic = ['(Empty)']; }
        });
        console.log(response);
        return response;
      })
      .catch(failure => failure)
      .finally(() => null);

  }
}
